import * as moment from 'moment-timezone';
export var isDateBefore = function (firstDate, secondDate) {
    return moment(firstDate).isBefore(secondDate);
};
export var isDateSameOrBefore = function (firstDate, secondDate) {
    return moment(firstDate).isSameOrBefore(secondDate);
};
export var isValidTimeFormat = function (time, format) {
    var currentInput = moment(time, format, true);
    return currentInput.isValid();
};
export var getStartOfDay = function (time, timeFormat, outputFormat) {
    return moment(time, timeFormat).startOf('day').format(outputFormat);
};
export var getEndOfDay = function (time, timeFormat, outputFormat) {
    return moment(time, timeFormat).endOf('day').format(outputFormat);
};
export var isStartOfDayBeforeNow = function (time, format) {
    return moment(time, format).startOf('day').isBefore(moment());
};
export var isEndOfDayBeforeNow = function (time, format) {
    return moment(time, format).endOf('day').isBefore(moment());
};
export var formatDate = function (date, outputFormat) {
    if (outputFormat === void 0) { outputFormat = 'MM/DD/YYYY'; }
    return moment(date).format(outputFormat);
};
export var isValidDateObj = function (dateObj) {
    // year, month, and day should exist in date object
    return !!(dateObj === null || dateObj === void 0 ? void 0 : dateObj.year) && !!(dateObj === null || dateObj === void 0 ? void 0 : dateObj.month) && !!(dateObj === null || dateObj === void 0 ? void 0 : dateObj.day);
};
export var formatDateToObject = function (date, format) {
    if (format === void 0) { format = 'MM/DD/YYYY'; }
    var formattedDate = moment(date, format);
    return {
        year: formattedDate.year(),
        month: formattedDate.month() + 1,
        day: formattedDate.date(),
    };
};
export var formatDateObjToDateString = function (dateObj, format) {
    if (format === void 0) { format = 'MM/DD/YYYY'; }
    if (!isValidDateObj(dateObj))
        return '';
    var year = dateObj.year, month = dateObj.month, day = dateObj.day;
    var dateInput = year + "/" + month + "/" + day;
    var momentDate = moment(dateInput, 'YYYY/MM/DD');
    return momentDate.format(format);
};
var formatTime = function (time, timeFormat, outputFormat) {
    if (timeFormat === void 0) { timeFormat = 'HH:mm'; }
    if (outputFormat === void 0) { outputFormat = 'h:mm A'; }
    return moment(time, timeFormat).format(outputFormat);
};
export var formatTimeObjToTimeString = function (timeObj, format) {
    if (format === void 0) { format = 'h:mm A'; }
    if (!timeObj)
        return null;
    var hours = timeObj.hours, minutes = timeObj.minutes;
    var timeInput = hours + ":" + minutes;
    var momentTime = moment(timeInput, 'HH:mm');
    return momentTime.format(format);
};
// format: MM/DD/YYYY
export var formatJsDateToString = function (dateObj) {
    var date = typeof dateObj === 'string' ? new Date(dateObj) : dateObj;
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return month + '/' + day + '/' + year;
};
export default formatTime;
